import { SERVER_URL } from '../constants';

// Thin fetch wrapper shared by every API class. Mirrors the HttpRequest base
// from stratum-analytical: it owns the base URL, default headers, bearer-token
// injection and JSON (or FormData) body handling.
class HttpRequest {
  constructor(uri = '', httpOptions = {}) {
    this.baseUrl = `${SERVER_URL}${uri ? `/${uri}` : ''}`;
    this.httpOptions = { contentType: 'application/json', ...httpOptions };
  }

  get headers() {
    const headers = {};
    if (this.httpOptions.contentType) {
      headers['Content-Type'] = this.httpOptions.contentType;
    }
    return headers;
  }

  getToken() {
    const token = localStorage.getItem('token');
    if (!token || token === 'undefined') return '';
    try {
      return JSON.parse(token);
    } catch {
      return token;
    }
  }

  async request(url, requestOptions = {}) {
    const fullUrl = !url
      ? this.baseUrl
      : url.startsWith('http')
        ? url
        : `${this.baseUrl}${url}`;

    let headers = { ...this.headers, ...requestOptions.headers };

    const token = this.getToken();
    if (token) headers.Authorization = `Bearer ${token}`;

    // Let the browser set the multipart boundary when sending FormData.
    const isFormData = requestOptions.body instanceof FormData;
    if (isFormData) delete headers['Content-Type'];

    const res = await fetch(fullUrl, {
      method: requestOptions.method || 'GET',
      headers,
      body: requestOptions.body
        ? isFormData
          ? requestOptions.body
          : JSON.stringify(requestOptions.body)
        : undefined,
    });

    let body = null;
    try {
      body = await res.json();
    } catch {
      // no JSON body
    }

    // Auto-logout on an authenticated request that comes back unauthorized
    // (expired/invalid token). `token` guards against treating a failed login
    // — which carries no token — as a session expiry.
    if (res.status === 401 && token) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.setItem('sessionExpired', '1');
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
      throw body || new Error('Session expired');
    }

    if (!res.ok || (body && body.statusCode >= 400)) {
      throw body || new Error(`Request failed: ${res.status}`);
    }
    return body;
  }

  get(url, requestOptions)    { return this.request(url, { ...requestOptions, method: 'GET' }); }
  post(url, requestOptions)   { return this.request(url, { ...requestOptions, method: 'POST' }); }
  put(url, requestOptions)    { return this.request(url, { ...requestOptions, method: 'PUT' }); }
  delete(url, requestOptions) { return this.request(url, { ...requestOptions, method: 'DELETE' }); }
}

export default HttpRequest;
